import { ReactElement } from 'react';

interface DisplayProps {
    show: boolean;
    children: ReactElement;
}
export const Display = function (props: DisplayProps) {
    let { show } = props;

    return show ? props.children : null;
};
